module.exports = __webpack_public_path__ + "5307f2059e4c3f98ee2b66577c82175b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000I7A.png
// module id = 1587
// module chunks = 0